import axios from "axios";
import React, { createContext } from "react";
import { baseURL } from "../Config/Config";


export const ProfContext = createContext()

export const ProfProvider = ({ children }) => {
    const [profData, setProfData] = React.useState()
    React.useEffect(() => {
        axios.get(`${baseURL}professiogramma/category-list/`).then((response) => {
            setProfData(response.data)
        }).catch((err) => {
            console.log(err)
        })
    }, [])
    return (
        <ProfContext.Provider value={[profData, setProfData]}>
            {children}
        </ProfContext.Provider>
    )
}

